<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { userService } from "@/services";

export default {
  name: 'App', 
  data(){
    return {
      style: {
        'height':window.innerHeight+'px',
        'background-color':'white'
      }
    }
  },
  mounted(){
    userService.getUsuarioInicio();
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  methods:{
    onResize () {
      this.style = {
        'height':window.innerHeight+'px',
        'background-color':'white'
      }
    }
  }
}
</script>

<style>
</style>

